export default __webpack_public_path__ + "c4aec2f3498421f91d9f066ba8ed5626.svg";